// extracted by mini-css-extract-plugin
export var accent = "_2g-4";
export var add = "_2g-j";
export var addIcon = "_2g-k";
export var deleteIcon = "_2g-i";
export var disabled = "_2g-9";
export var ellipsis = "_2g-f";
export var error = "_2g-3";
export var form = "_2g-5";
export var hideFocus = "_2g-2";
export var icon = "_2g-7";
export var input = "_2g-e";
export var listItem = "_2g-h";
export var mediumHeight = "_2g-b";
export var noBorder = "_2g-8";
export var noRadius = "_2g-1";
export var shortHeight = "_2g-a";
export var tallHeight = "_2g-c";
export var textInput = "_2g-0";
export var vertical = "_2g-g";
export var veryTallHeight = "_2g-d";
export var widget = "_2g-6";